<gstar-layout>
  <router-outlet />
</gstar-layout>
